import axios from "axios";
import firebase from "firebase";

const offersApiService = {
  async get() {
    const userIdToken = await firebase.auth().currentUser.getIdToken(true);
    const endpoint = "/api/offer/all";

    return new Promise((resolve, reject) => {
      axios.get(endpoint, { headers: { "Authorization": userIdToken } })
        .then(response => resolve(response.data.offers))
        .catch(reason => reject(new Error("Offers API Error. " + reason.message)));
    });
  }
};

export default offersApiService;
